import { Button } from '@alifd/next';
import { Space } from 'antd';
import React from 'react';

import type { ActionButton } from '../../types';

type TableActionButtonsProps = {
  buttons: ActionButton[];
  clickEditButton: () => void;
  checkDetail: () => void;
  deleteRoute: () => void;
};

const TableActionButtons = ({
  buttons,
  clickEditButton,
  checkDetail,
  deleteRoute,
}: TableActionButtonsProps) => {
  const onClick = (label: string) => {
    if (label === '查看') {
      checkDetail();
    } else if (label === '編輯') {
      clickEditButton();
    } else if (label === '刪除') {
      deleteRoute();
    }
  };

  return (
    <Space>
      {buttons.map(({ label, type }) => (
        <Button
          type={type}
          key={label}
          warning={label === '刪除'}
          onClick={() => onClick(label)}
        >
          {label}
        </Button>
      ))}
    </Space>
  );
};

export default TableActionButtons;
